import {
  PageName, ProcessStatus, WebMetricsData, WebMetricsEvent
} from './web-metrics.constants';

// write a function to get the webMetricsData for a specific tag
export function getWebMetricsData(tag: string): WebMetricsData | undefined {
  return webMetricsDataTagMap[tag];
}

const webMetricsDataTagMap: Record<string, WebMetricsData> = {
  overviewTag: {
    event: WebMetricsEvent.PAGE_CHANGE,
    page: {
      name: PageName.OVERVIEW
    },
    process: {
      name: 'myins:seamless:enrollment:flow',
      status: ProcessStatus.START
    }
  },
  customerInfoTag: {
    event: WebMetricsEvent.PAGE_CHANGE,
    page: {
      name: PageName.CUSTOMER_IDENTIFICATION
    },
    process: {
      name: 'myins:seamless:enrollment:flow'
    }
  },
  confirmYourNumberTag: {
    event: WebMetricsEvent.PAGE_CHANGE,
    page: {
      name: PageName.PHONE_NUMBER_LIST
    },
    process: {
      name: 'myins:seamless:enrollment:flow'
    }
  },
  accountHolderPopupTag: {
    event: WebMetricsEvent.PAGE_CHANGE,
    page: {
      name: PageName.ACCOUNT_NUMBER_POPUP
    },
    process: {
      name: 'myins:seamless:enrollment:flow'
    }
  },
  primaryPolicyHolderNotFoundTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.NOT_FOUND_PRIMARY_POLICY_HOLDER_ERROR
    },
    error: {
      code: '400',
      message: 'Primary policy holder not found'
    }
  },
  secondaryPolicyHolderNotFoundTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.NOT_FOUND_SECONDARY_POLICY_HOLDER_ERROR
    },
    error: {
      code: '400',
      message: 'Secondary policy holder not found'
    }
  },
  phoneNumberConfirmation: {
    event: WebMetricsEvent.PAGE_CHANGE,
    page: {
      name: PageName.PHONE_NUMBER_LIST
    },
    process: {
      name: 'myins:seamless:enrollment:flow'
    }
  },
  existingAccountTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.EXISTING_ACCOUNT_ERROR
    },
    error: {
      code: '400',
      message: 'Account already exists'
    }
  },
  sessionExpiredTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.SESSION_EXPIRED
    },
    error: {
      code: '400',
      message: 'Session expired'
    }
  },
  internalServerErrorTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.APPLICATION_ERROR
    },
    error: {
      code: '500',
      message: 'Internal server error'
    }
  },
  technicalServerErrorTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.TECHNICAL_ERROR
    },
    error: {
      code: '500',
      message: 'Technical server error'
    }
  },
  functionalServerErrorTag: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.FUNCTIONAL_ERROR
    },
    error: {
      code: '500',
      message: 'Functional server error'
    }
  },
  404: {
    event: WebMetricsEvent.ERROR,
    page: {
      name: PageName.PAGE_NOT_FOUND
    },
    error: {
      code: '404',
      message: 'Page not found'
    }
  }
};
